import { UserStatusType } from '@pu/models';

export const userStatusTypes: UserStatusType[] = ['Probation', 'Active', 'Offboarding'];
